import DOMPurify from 'dompurify'
import { RICH_TEXT_TAGS, RICH_TEXT_ATTRIBUTES_FLAT } from '@butter/library/shared'
import { cn } from '#utils'

interface HtmlContentProps {
  html: string
  className?: string
}

/**
 * Renders sanitized rich-text HTML produced by `RichTextEditor`.
 *
 * The allowlist is shared with the API's write-side sanitizer via
 * `@butter/library/shared` — edit it there, never here, or the two sides drift
 * and content silently disappears between save and render.
 */
export function HtmlContent({ html, className }: HtmlContentProps) {
  const sanitizedHtml = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [...RICH_TEXT_TAGS],
    ALLOWED_ATTR: [...RICH_TEXT_ATTRIBUTES_FLAT],
  })

  return (
    <div
      className={cn('prose prose-sm max-w-none', className)}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  )
}
